import * as yup from 'yup';
import { CancelRequestType, FormFields, RefundRequestType } from './types';
export const validationSchema = yup.object({
    [FormFields.transaction]: yup.object().required('Select a transaction to refund.'),
    [FormFields.cancelRequestType]: yup
        .string()
        .oneOf([CancelRequestType.Schedule, CancelRequestType.Now])
        .required(),
    [FormFields.refundRequestType]: yup
        .string()
        .oneOf([RefundRequestType.full, RefundRequestType.prorated, RefundRequestType.custom])
        .required(),
    [FormFields.customAmount]: yup
        .number()
        .when([FormFields.refundRequestType, FormFields.transaction], (refundRequestType, transaction) => {
        if (refundRequestType === RefundRequestType.custom)
            return yup
                .number()
                .min(transaction.refundRequest.options.custom.minAmount / 100)
                .max(transaction.refundRequest.options.custom.maxAmount / 100)
                .required();
        return yup.number();
    }),
});
export const disabledChargeReasonsMap = {
    AlreadyRefunded: 'This transaction has already been refunded',
    TooSmallAmount: 'The minimum refund amount is $1.00',
    IapCharge: 'Refunds are not available for in-app purchases',
};
